// All global data should be stored in this class so we can manage in cleanly.
import { SharedData } from './shareddata';
import type { NotificationToast } from './stdtypes';
import { generateRandomKey } from './util';

export class AppData {
    // put any global things you need to access in here rather than using globals.
    // This can be used for sessionData, shared react context, active-popup tracking, and other things.
    private notificationToasts: NotificationToast[] = [];
    private notificationToastListeners: Set<() => void> = new Set();

    addNotificationToast(notificationToast: NotificationToast) {
        this.notificationToasts = [...this.notificationToasts, notificationToast];
        this.notifyNotificationToastListeners();
    }

    removeNotificationToast(id: string) {
        this.notificationToasts = [...this.notificationToasts.filter((toast) => toast.id !== id)];
        this.notifyNotificationToastListeners();
    }
    getNotificationToasts(): NotificationToast[] {
        return this.notificationToasts || [];
    }
    subscribeToNotificationToasts(callback: () => void): () => void {
        this.notificationToastListeners.add(callback);
        return () => {
            this.notificationToastListeners.delete(callback);
        };
    }
    private notifyNotificationToastListeners() {
        this.notificationToastListeners.forEach((callback) => callback());
    }

    sharedDataMap: Record<string, Record<string, SharedData>> = {};
    getSharedData(structureKey: string, instanceKey: string) {
        if (!this.sharedDataMap[structureKey]) {
            this.sharedDataMap[structureKey] = {};
        }
        if (!this.sharedDataMap[structureKey][instanceKey]) {
            this.sharedDataMap[structureKey][instanceKey] = new SharedData();
        }
        return this.sharedDataMap[structureKey][instanceKey];
    }

    gotoAfterAuth: { structureKey: string; instanceKey: string; screenKey?: string; params: any } | null = null;
    setGotoAfterAuth(gotoAfterAuth: { structureKey: string; instanceKey: string; screenKey?: string; params: any }) {
        this.gotoAfterAuth = gotoAfterAuth;
    }
    getGotoAfterAuth() {
        return this.gotoAfterAuth;
    }
    clearGotoAfterAuth() {
        this.gotoAfterAuth = null;
    }

    csrfToken: string | null = null;
    getCSRFToken() {
        if (!this.csrfToken) {
            this.csrfToken = this._generateCSRFToken();
        }
        return this.csrfToken;
    }
    isValidCSRFToken(csrfToken: string) {
        return csrfToken && this.csrfToken === csrfToken;
    }
    _generateCSRFToken() {
        return generateRandomKey(16);
    }
    clearCSRFToken() {
        this.csrfToken = null;
    }
}
